module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Blurb"
  }, [_vm._v("Sheila L. Rutter grew up on a horse farm in a small town in Michigan. She joined the United States Air Force when she was twenty years old. Sheila did her four-year tour in Texas, Okinawa, Japan, and Florida. She married, had three beautiful children, was widowed young, and, after a few years, remarried. Sheila has been writing poetry and short stories for many years, with her first poem published in 2002. "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Time with Grandma: Fun Family History Workbook")]), _vm._v(" in 2020. She has a degree in graphic design and photography. Sheila knows the importance of family and would like to help parents teach their children manners by keeping it fun and memorable.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781647508562_txt3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Heading ParaOverride-1"
  }, [_vm._v("Copyright © Sheila L. Rutter 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods,without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Ordering Information")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("Quantity sales: Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Publisher’s Cataloging-in-Publication data")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("Rutter, Sheila L.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("Amelia Teaches Manners")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("ISBN 9781647508562 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("ISBN 9798891557116 (Hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("ISBN 9798891557123 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("Library of Congress Control Number: 2024914118")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("www.austinmacauley.com/us")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("Austin Macauley Publishers LLC")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("40 Wall Street, 33rd Floor, Suite 3302 ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("New York, NY 10005")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR ParaOverride-1"
  }, [_vm._v("USA")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("mail-usa@austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-CR"
  }, [_vm._v("+1 (646) 5125767")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("Amelia is on a quest to teach manners to every animal she meets.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("She treks through land, rivers, sand, and sea and knows they’ll be happy to learn manners from her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("She knows she must follow the rainbow home, but she finds herself in dangerous waters floating out to sea.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Thankfully, one of her new friends gives her a helpful push to lead her home to the African bush.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Cover_Fold_Color_(1).jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("A rainbow is multicolored. It forms when light strikes water droplets. The light reflects and refracts off water particles in the air, such as rain or mist.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lucas the brown pony whinnies, “Good morning, baby elephant. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I’m hungry and I want some oats!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Sofie and Sadie, the fluffy white sheep, demand, “Give us some hay before you walk away, or we’ll baa-baa-baa all day!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Illustration_1_-_2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Amelia grunts, raising her trunk. “It’s more polite to say… May I have some oats and hay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lucas quickly replies, “Yes, we’re sorry for being rude. We’re hungry and just want some food.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Txt ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Be polite! Show respect!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Rutter,_Sheila_MS_(4)_Page_03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Always ask politely and say, (May I?) when asking for something.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Be kind to others and show respect to your elders.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Trace the big letters with your finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Alara nastily clucks, “Camdyn, get out of my corral! You messy pink pig!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Camdyn grunts with his snout to the sky, “Not until I get a bigger mud pit to roll and dig!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Amelia snorts, “Be nice and use your manners.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Illustration_5_-_6.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Alara hums, “Camdyn, please excuse me for being rude; we’re friends and shouldn’t feud.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Camdyn squeals, “I accept your apology and must admit, I already miss my little mud pit.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "Kind"
  }, [_vm._v("Say, please, and be kind!")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Rutter,_Sheila_MS_(4)_Page_05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("May I please have an apple and some juice?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Could you please help me clean my room?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Trace the big letters with your fin")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Txt ParaOverride-1"
  }, [_vm._v("Emmy,the white furry bunny, squeaks sadly,“I’m lost and have no home!”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“I’m Carlos, the mighty rooster,” he cock-a-doodles, shaking his comb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“Don’t be sad, Carlos is here. I will share my coop with you, so don’t you fear.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Emmy thumps happily with her long furry foot, “Thank you so much, Carlos, I’ve been sleeping in soot!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Illustration_9_-_10_(1).jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Amelia excitedly waves her trunk in the air and says, “Awesome sharing from a fairly odd pair.”")])]), _vm._v(" "), _c('p', {
    staticClass: "caring"
  }, [_vm._v("Sharing is caring.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Rutter,_Sheila_MS_(4)_Page_07.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Sharing has a positive effect and will make you feel better. Be kind to others and share your toys.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Trace the big letters with your finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lennix, the gray dolphin, squeaks and clicks, “Get out of my way, little elephant, before you get tossed!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Hudson, the wise sea turtle, clicks and clacks, “Lennix, use your manners, I think she’s lost!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Illustration_13_-_14.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Amelia rumbles, “I’m sorry I’m in your way, but I’m lost and floating to shore.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“If you could please push me in the right direction, I would be so thankful and on my way for sure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“Help her, Lennix!”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "helpful"
  }, [_vm._v("Be helpful every day!")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Rutter,_Sheila_MS_(4)_Page_09.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Help your parents, your grandparents, your teacher, or someone else.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Who will you help today?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Trace the big letters with your finger.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "Txt-1123232"
  }, [_vm._v("Trey, the killer whale, blows his mighty stack. “You’re getting into dangerous waters my tasty friend, all though I’m sure you’d make a savory snack.”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Penelope, the purple octopus, points with a tentacle, “Trey! Be nice and leave her be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“Help her so she doesn’t float too far out to sea.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Illustration_17_-_18.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Amelia nervously waves her trunk. “I would be so thankful for a little push.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“My family is just around the corner in the African bush.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Trey blows as he leaps so forcefully, “I suppose I can help since you’ve asked so politely.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "Thank-u"
  }, [_vm._v("Always say thank you!")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-11",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Rutter,_Sheila_MS_(4)_Page_11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Thank you for being my friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Thank you for making my lunch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Trace the big letters with your finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Image-on-next-page- ParaOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Illustration_21_-_22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mama elephant sadly rumbles and cries, “Hear me, baby Amelia, as Mama calls to lead you home!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“I hope and pray you find your way and hear me as I roam.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Sorry"
  }, [_vm._v("I’m sorry!")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-13",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Rutter,_Sheila_MS_(4)_Page_13.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Say you are sorry when you’re wrong or when you’ve hurt someone’s feelings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’m sorry, I didn’t listen.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Trace the big letters with your finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Luna, the Hippo unhappily, asks, “Excuse me, does anyone know when Amelia will return?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“If my little Lotti were missing I would be terribly anxious with concern.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-14",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Illustration_25_-_26.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Finn, the zebra, hangs his head in worry. “I hope she’s okay, I hope she’s fine; I hope my sweet friend comes home in record time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Josie the giraffe softly hums, “Amelia is smart, lovable, and kind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“She’ll find her way home, so leave your worries behind.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "Excuse-"
  }, [_vm._v("Excuse me.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Rutter,_Sheila_MS_(4)_Page_15.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Say ‘Excuse me’ when you have a question or if you walk in front of someone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Please excuse my reach.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Trace the big letters with your finger.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "Txt-1123232"
  }, [_vm._v("Mama elephant happily rumbles and trumpets, “Amelia is safely home from her quest.”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“May her new friends remember their manners and know they’re truly blessed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-15",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/86907_-_Amelia_Teaches_-_Illustration_29_-_30.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Amelia excitedly snorts. “Mama, I’ve missed you, your tight hugs and all your love.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“I followed the rainbow just like you said and let Papa’s spirit guide me from above.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "end-txt"
  }, [_vm._v("THE END")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64aa716e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epub.vue
// module id = 57
// module chunks = 0